module.exports = __webpack_public_path__ + "img/kort-25.19f368dc.jpg";